import { type } from "./common";

export function requestUrl(match){  //将match的url修正为不带/结尾的
    let url = type(match)==="string"? match:match.url;
    return url.replace(/\/$/, '');
}